import  OriginSwitchButton from './SwitchButton';
import Item from './SwitchButtonItem';
import './style'

type SwitchButtonProps = typeof OriginSwitchButton & {
  Item: typeof Item;
};

const _SwitchButton = OriginSwitchButton as SwitchButtonProps;
_SwitchButton.Item = Item;

export const SwitchButton = _SwitchButton;

export default SwitchButton;

export * from './interface';
